import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-google-review',
  templateUrl: './google-review.component.html',
  styleUrls: ['./google-review.component.scss'],
})
export class GoogleReviewComponent {
  @Input() link!: string;
}
